import { hydrate } from 'svelte';
import FeaturedJobs from './FeaturedJobs.svelte';

const el = document.getElementById('featured-jobs');
if (el) {
  const raw = el.getAttribute('data-props');
  const data = raw ? JSON.parse(raw) : { jobs: [], hasMore: false, initialPageSize: 0 };
  console.log('Featured jobs data:', data);

  hydrate(FeaturedJobs, {
    target: el,
    props: { 
      initialJobs: data.jobs || [],
      initialHasMore: data.hasMore || false,
      initialPageSize: data.initialPageSize || 6
    }
  });
} else {
  console.error('FeaturedJobs element not found');
} 